import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (

      <div class="py-6 container">
        <div class="columns mt-4">
          <div class="column is-flex-grow-2">
            <div class="ant-card ant-card-bordered">
              <div class="ant-card-body">
                <article class="media pool-detail" style={{ position: "relative" }}>
                  <figure class="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: "hidden" }}>
                    <p class="image is-48x48"><img src="https://i.postimg.cc/ryrfgQxf/500x500.png" alt="" style={{ filter: "grayscale(0)" }} /></p>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <div class="is-flex is-align-items-center">
                        <div class="is-flex-grow-1 is-flex single-title">
                          <h1 class="title mr-2">Goal Champion Subscription</h1>
                          <div class="flex status-wrapper">
                            <div class="flex"><a href="https://t.me/gemsbynikisha/243" class="is-flex tag is-small mr-2" target="_blank" rel="noopener nofollow noreferrer" style={{ backgroundColor: "rgb(223, 95, 248)", color: "rgb(255, 255, 255)" }}>SAFU</a>
                              <a href="https://github.com/Audit-Ace/Audits-Smart-Contracts/blob/main/Goal%20Champion%20Audit%20Report.pdf" class="is-flex tag is-small mr-2" target="_blank" rel="noopener nofollow noreferrer" style={{ backgroundColor: "rgb(0, 188, 212)", color: "rgb(255, 255, 255)" }}>Audit</a>
                              <a href="https://pinksale.notion.site/Goal-Champion-KYC-Verification-a0fa03df14ee4a019ada791c774535b9" class="is-flex tag is-success is-small mr-2" target="_blank" rel="noopener nofollow noreferrer">KYC</a>
                            </div>
                            <div class="status-space"></div>
                            <div class="flex">
                              <div class="mr-2">
                                <div class="subscription-bell is-clickable small" title="Add to favorite" style={{ lineHeight: "18px" }}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="10" width="10" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd"
                                    d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 01.176-.17C12.72-3.042 23.333 4.867 8 15z"
                                    clip-rule="evenodd"></path>
                                </svg></div>
                              </div>
                              <div><span class="is-flex status-dot inprogress"><svg
                                stroke="currentColor"
                                fill="currentColor" stroke-width="0"
                                viewBox="0 0 16 16" height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8" cy="8" r="8"></circle>
                              </svg><span
                                style={{ whiteSpace: "nowrap" }}>Sale
                                  Live</span></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="is-flex mt-1 mb-2">
                        <div><a href="https://goalchampion.io/" rel="nofollow noreferrer" target="_blank" class="mr-4 is-size-5"><svg stroke="currentColor"
                          fill="none" stroke-width="2" viewBox="0 0 24 24"
                          stroke-linecap="round" stroke-linejoin="round"
                          height="1em" width="1em"
                          xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="2" y1="12" x2="22" y2="12"></line>
                          <path
                            d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                          </path>
                        </svg></a><a href="https://twitter.com/goalchampionbsc" rel="nofollow noreferrer" target="_blank" class="mr-4 is-size-5"><svg stroke="currentColor"
                          fill="none" stroke-width="2" viewBox="0 0 24 24"
                          stroke-linecap="round" stroke-linejoin="round"
                          height="1em" width="1em"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z">
                          </path>
                        </svg></a><a href="https://t.me/goalchampionchannel" rel="nofollow noreferrer" target="_blank" class="mr-4 is-size-5"><svg stroke="currentColor"
                          fill="currentColor" stroke-width="0"
                          viewBox="0 0 448 512" height="1em" width="1em"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z">
                          </path>
                        </svg></a></div>
                      </div>
                      <div class="ant-typography">Goal Champion is an organization creates rewards-based crowdfunding campaigns for sporting events. 🔥 World Cup 2022 - Goal Champion Pool has launched ✅. #ConnectMarketing with Huobi , Gate. BinanceLive
                        🔥🔥.SAFU+AUDIT+KYC ✅ CMC &amp; CGK Fasttrack 🔥. Low Tax High Profit✅ </div>
                    </div>
                    <div class="ant-typography">
                      <div class="YoutubeEmbeded_root__3mhbb"><iframe width="853" height="480" src="https://www.youtube.com/embed/Y2eEBoJ0xRk" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""
                        title="Pool Intro"></iframe></div>
                    </div>
                  </div>
                </article>
                <div class="table-container mt-0">
                  <table>
                    <tbody>
                      <tr>
                        <td>Subscription Address</td>
                        <td class="has-text-right"><a href="https://bscscan.com/address/0xb7a4e68a4ebdfbcb85dd170506f5a440d9e7503a" target="_blank" rel="noreferrer nofollow">0xb7a4e68a4ebdfbcb85dd170506f5a440d9e7503a</a>
                        </td>
                      </tr>
                      <tr>
                        <td>Token Name</td>
                        <td class="has-text-right">Goal Champion</td>
                      </tr>
                      <tr>
                        <td>Token Symbol</td>
                        <td class="has-text-right">GC</td>
                      </tr>
                      <tr>
                        <td>Token Decimals</td>
                        <td class="has-text-right">18</td>
                      </tr>
                      <tr>
                        <td>Token Address</td>
                        <td class="has-text-right"><a class="mr-1" href="https://bscscan.com/address/0x1F93D65D5115BC8785920d75120eA26a52ca4392" target="_blank" rel="noreferrer nofollow">0x1F93D65D5115BC8785920d75120eA26a52ca4392</a><br />
                          <p class="help is-info">(Do not send BNB to the token address!) </p>
                        </td>
                      </tr>
                      <tr>
                        <td>Total Supply</td>
                        <td class="has-text-right">2,000,000 GC</td>
                      </tr>
                      <tr>
                        <td>HardCap Tokens</td>
                        <td class="has-text-right">400,000 GC (299.99850000749996 BNB)
                        </td>
                      </tr>
                      <tr>
                        <td>SoftCap Tokens</td>
                        <td class="has-text-right">210,000 GC (157.49921250393749 BNB)
                        </td>
                      </tr>
                      <tr>
                        <td>Tokens For Liquidity</td>
                        <td class="has-text-right">228,000 GC</td>
                      </tr>
                      <tr>
                        <td>Subscription Rate</td>
                        <td class="has-text-right">1 BNB = 1,333.34 GC</td>
                      </tr>
                      <tr>
                        <td>Listing Rate</td>
                        <td class="has-text-right">1 BNB = 1,333.34 GC</td>
                      </tr>
                      <tr>
                        <td>Unsold Tokens</td>
                        <td class="has-text-right">Burn</td>
                      </tr>
                      <tr>
                        <td>Start Time</td>
                        <td class="has-text-right">2022.11.16 14:00 (UTC)</td>
                      </tr>
                      <tr>
                        <td>End Time</td>
                        <td class="has-text-right">2022.11.17 14:00 (UTC)</td>
                      </tr>
                      <tr>
                        <td>Listing On</td>
                        <td class="has-text-right"><a class="mr-1" href="https://pancakeswap.finance/swap?outputCurrency=0x1F93D65D5115BC8785920d75120eA26a52ca4392" target="_blank" rel="noreferrer nofollow">Pancakeswap</a></td>
                      </tr>
                      <tr>
                        <td>Liquidity Percent</td>
                        <td class="has-text-right">60%</td>
                      </tr>
                      <tr>
                        <td>Liquidity Lockup Time</td>
                        <td class="has-text-right">365 days after pool ends</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div style={{ height: "24px" }}></div>
            <div class="ant-card ant-card-bordered">
              <div class="ant-card-head">
                <div class="ant-card-head-wrapper">
                  <div class="ant-card-head-title">Token Metrics</div>
                </div>
              </div>
              <div class="ant-card-body">
                <div class="has-text-centered">
                  <div style={{ maxWidth: "400px", margin: "auto", height: "300px", overflowY: "hidden" }}>
                    <div class="TokenMetric_root__29Tdv"><canvas height="500" width="500" data-testid="canvas" role="img" style={{ display: "block", boxSizing: "border-box", height: "400px", width: "400px" }}></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="LockRecord_root__31Eay">
              <div class="ant-card ant-card-bordered">
                <div class="ant-card-head">
                  <div class="ant-card-head-wrapper">
                    <div class="ant-card-head-title">Lock records</div>
                    <div class="ant-card-extra">
                      <div class="has-text-right"><a href="/pinklock/detail/0x1F93D65D5115BC8785920d75120eA26a52ca4392?chain=BSC">View
                        All</a></div>
                    </div>
                  </div>
                </div>
                <div class="ant-card-body">
                  <div class="ant-spin-nested-loading">
                    <div class="ant-spin-container">
                      <ul class="ant-list-items">
                        <li class="ant-list-item">
                          <div class="LockRecord_tvl__1cBpD"><strong>Amount</strong>
                          </div>
                          <div class="LockRecord_tvl__1cBpD"><strong>Unlock
                            time(UTC)</strong></div>
                          <div style={{ opacity: "0" }}>View</div>
                        </li>
                      </ul>
                      <div class="ant-list ant-list-split">
                        <div class="ant-spin-nested-loading">
                          <div class="ant-spin-container">
                            <ul class="ant-list-items">
                              <li class="ant-list-item">
                                <div class="LockRecord_tvl__1cBpD">
                                  <div class="LockRecord_value__1gWYF">80,000
                                  </div>
                                </div>
                                <div class="LockRecord_tvl__1cBpD">2022.12.17 00:00 </div><a href="/pinklock/record/1052381?chain=BSC">View</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <hr></hr>
                      <ul class="ant-list-items">
                        <li class="ant-list-item">
                          <div class="LockRecord_tvl__1cBpD"><strong>Amount</strong>
                          </div>
                          <div class="LockRecord_tvl__1cBpD"><strong>Cycle</strong>
                          </div>
                          <div class="LockRecord_tvl__1cBpD"><strong>TGE</strong>
                          </div>
                          <div class="LockRecord_tvl__1cBpD"><strong>Unlock
                            time(UTC)</strong></div>
                          <div style={{ opacity: "0" }}>View</div>
                        </li>
                      </ul>
                      <div class="ant-list ant-list-split">
                        <div class="ant-spin-nested-loading">
                          <div class="ant-spin-container">
                            <ul class="ant-list-items">
                              <li class="ant-list-item">
                                <div class="LockRecord_tvl__1cBpD">
                                  <div class="LockRecord_value__1gWYF">600,000
                                  </div>
                                </div>
                                <div class="LockRecord_tvl__1cBpD">10% each 30 days </div>
                                <div class="LockRecord_tvl__1cBpD">10%</div>
                                <div class="LockRecord_tvl__1cBpD">2022.12.17 00:00 </div><a href="/pinklock/record/1052375?chain=BSC">View</a>
                              </li>
                              <li class="ant-list-item">
                                <div class="LockRecord_tvl__1cBpD">
                                  <div class="LockRecord_value__1gWYF">120,000
                                  </div>
                                </div>
                                <div class="LockRecord_tvl__1cBpD">10% each 30 days </div>
                                <div class="LockRecord_tvl__1cBpD">10%</div>
                                <div class="LockRecord_tvl__1cBpD">2022.12.17 00:00 </div><a href="/pinklock/record/1052378?chain=BSC">View</a>
                              </li>
                              <li class="ant-list-item">
                                <div class="LockRecord_tvl__1cBpD">
                                  <div class="LockRecord_value__1gWYF">300,000
                                  </div>
                                </div>
                                <div class="LockRecord_tvl__1cBpD">10% each 30 days </div>
                                <div class="LockRecord_tvl__1cBpD">10%</div>
                                <div class="LockRecord_tvl__1cBpD">2022.12.17 00:00 </div><a href="/pinklock/record/1052379?chain=BSC">View</a>
                              </li>
                              <li class="ant-list-item">
                                <div class="LockRecord_tvl__1cBpD">
                                  <div class="LockRecord_value__1gWYF">40,000
                                  </div>
                                </div>
                                <div class="LockRecord_tvl__1cBpD">10% each 30 days </div>
                                <div class="LockRecord_tvl__1cBpD">10%</div>
                                <div class="LockRecord_tvl__1cBpD">2023.05.17 00:00 </div><a href="/pinklock/record/1052377?chain=BSC">View</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="has-text-centered mt-4">
                    <ul class="ant-pagination" unselectable="unselectable">
                      <li title="Previous Page" class="ant-pagination-prev ant-pagination-disabled" aria-disabled="true"><button class="ant-pagination-item-link" type="button" tabindex="-1" disabled=""><span role="img"
                        aria-label="left" class="anticon anticon-left"><svg
                          viewBox="64 64 896 896" focusable="false"
                          data-icon="left" width="1em" height="1em"
                          fill="currentColor" aria-hidden="true">
                          <path
                            d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z">
                          </path>
                        </svg></span></button></li>
                      <li title="1" class="ant-pagination-item ant-pagination-item-1 ant-pagination-item-active" tabindex="0"><a rel="nofollow">1</a></li>
                      <li title="2" class="ant-pagination-item ant-pagination-item-2" tabindex="0"><a rel="nofollow">2</a></li>
                      <li title="Next Page" tabindex="0" class="ant-pagination-next" aria-disabled="false"><button class="ant-pagination-item-link" type="button" tabindex="-1"><span role="img"
                        aria-label="right" class="anticon anticon-right"><svg
                          viewBox="64 64 896 896" focusable="false"
                          data-icon="right" width="1em" height="1em"
                          fill="currentColor" aria-hidden="true">
                          <path
                            d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z">
                          </path>
                        </svg></span></button></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-flex-grow-1">
            <div class="ant-card ant-card-bordered">
              <div class="ant-card-body">
                <div data-show="true" class="ant-alert ant-alert-warning ant-alert-no-icon" role="alert" style={{ marginBottom: "10px" }}>
                  <div class="ant-alert-content">
                    <div class="ant-alert-message">Make sure the website is pinksale.finance! </div>
                    <div class="ant-alert-description"></div>
                  </div>
                </div>
                <form>
                  <div class="has-text-centered">
                    <p class="mb-2">Subscription Ends In</p>
                    <div class="has-text-centered"><strong><span
                      class="p-2 has-background-danger-light mr-2"
                      style={{ borderRadius: "4px" }}>00</span><span
                        class="p-2 has-background-danger-light mr-2"
                        style={{ borderRadius: "4px" }}>00</span><span
                          class="p-2 has-background-danger-light mr-2"
                          style={{ borderRadius: "4px" }}>01</span><span
                            class="p-2 has-background-danger-light mr-2"
                            style={{ borderRadius: "4px" }}>56</span></strong></div>
                  </div>
                  <div class="pb-4">
                    <div class="ant-progress ant-progress-line ant-progress-status-active ant-progress-default mt-4 mb-2">
                      <div class="ant-progress-outer">
                        <div class="ant-progress-inner">
                          <div class="ant-progress-bg" style={{ width: "100%", height: "15px", background: "rgba(72, 199, 116, 0.5)" }}>
                          </div>
                          <div class="ant-progress-success-bg" style={{ width: "2.09244%", height: "15px", backgroundColor: "rgb(72, 199, 116)" }}>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="is-flex is-align-items-center is-size-7">
                      <div class="is-flex-grow-1">14,337.226998554796 BNB</div>
                      <div class="is-flex-grow-1 has-text-right">299.99850000749996 BNB
                      </div>
                    </div>
                  </div>
                  <div class="field"><label class="label">Amount (max: 0.01206722705067559
                    BNB)</label>
                    <div class="control">
                      <div style={{ position: "relative" }}><input class="input" type="number" placeholder="0.0" /><a class="mr-2" style={{ position: "absolute", right: "8px", top: "4px" }}><b>MAX</b></a>
                      </div>
                    </div>
                  </div><button disabled="" type="button" class="ant-btn ant-btn-primary"><svg
                    stroke="currentColor" fill="currentColor" stroke-width="0"
                    viewBox="0 0 1024 1024" height="1em" width="1em"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z">
                    </path>
                  </svg><span class="ml-2">Commit with BNB</span></button>
                </form>
                <div class="has-text-centered has-text-primary mt-4"><span class="is-clickable"><u>View purchase history</u></span></div>
              </div>
            </div>
            <div style={{ height: "24px" }}></div>
            <div class="ant-card ant-card-bordered">
              <div class="ant-card-body">
                <div class="table-container">
                  <table>
                    <tbody>
                      <tr>
                        <td>Status</td>
                        <td class="has-text-right has-text-primary">inprogress</td>
                      </tr>
                      <tr>
                        <td>Sale Type</td>
                        <td class="has-text-right has-text-primary">Public</td>
                      </tr>
                      <tr>
                        <td>Current Raised</td>
                        <td class="has-text-right">299.9985 BNB (100%)</td>
                      </tr>
                      <tr>
                        <td>Hard Cap Per User</td>
                        <td class="has-text-right">2,667 GC (2.000239998800005999 BNB)
                        </td>
                      </tr>
                      <tr>
                        <td>Participants</td>
                        <td class="has-text-right">932</td>
                      </tr>
                      <tr>
                        <td>Max Allocation Requires</td>
                        <td class="has-text-right">90 BNB</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-flex-grow-2">
            <div class="ant-card ant-card-bordered">
              <div class="ant-card-body">
                <div id="disqus_thread"><iframe id="dsq-app5423" name="dsq-app5423" allowtransparency="true" frameborder="0" scrolling="no" tabindex="0" title="Disqus" width="100%" src="https://disqus.com/embed/comments/?base=default&amp;f=pinksale&amp;t_i=0xb7A4E68a4EBDFBcb85dD170506F5A440d9E7503a&amp;t_u=https%3A%2F%2Fpinksale.finance%2Flaunchpad%2F0xb7a4e68a4ebdfbcb85dd170506f5a440d9e7503a&amp;t_e=Goal%20Champion&amp;t_d=Goal%20Champion%20Subscription%20-%20How%20to%20Buy%20Goal%20Champion&amp;t_t=Goal%20Champion&amp;s_o=default&amp;l=en_US#version=4024f3e8f0ccf852c7dedd29fda27f2e"
                  style={{ width: "1px !important", minWidth: "100% !important", border: "none !important", overflow: "hidden !important", height: "757px !important" }} horizontalscrolling="no" verticalscrolling="no"></iframe><iframe id="indicator-north"
                    name="indicator-north" allowtransparency="true" frameborder="0" scrolling="no" tabindex="0" title="Disqus" style={{ width: " 464px !important", border: "none !important", overflow: "hidden !important", top: "0px !important", minWidth: "464px !important", maxWidth: "464px !important", position: "fixed !important", zIndex: "2147483646 !important", height: "29px !important", minHeight: "29px !important", maxHeight: "29px !important", display: "none !important" }}></iframe>
                  <iframe id="indicator-south" name="indicator-south" allowtransparency="true" frameborder="0" scrolling="no" tabindex="0" title="Disqus" style={{ width: "464px !important", border: "none !important", overflow: "hidden !important", bottom: "0px !important", minWidth: "464px !important", maxWidth: "464px !important", position: "fixed !important", zIndex: "2147483646 !important", height: "29px !important", minHeight: "29px !important", maxHeight: "29px !important", display: "none !important" }}></iframe>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-flex-grow-1"></div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
